import React, { useState } from "react";
import "./Button.scss";
import { Link } from "react-router-dom";

// Icons used
import { DownloadIcon, Play, Pause } from "../icons";

const ButtonWithIcon = ({
  variant = "primary", // Button style variant (e.g., primary, secondary)
  size = "md", // Button size (sm, md, lg)
  disabled = false, // Disable button interaction
  to = null, // Optional route link (if passed, renders <Link>)
  icon: Icon = DownloadIcon, // Optional icon component (default: DownloadIcon)
  playPause = false, // If true, toggles between play/pause icons
  videoRef = null, // Ref to a video element (for play/pause functionality)
  className = "", // Additional classes
  ...props // Remaining props passed to <button> or <Link>
}) => {
  const [isPlaying, setIsPlaying] = useState(false); // Track playing state (for playPause mode)

  // Handle click: toggle video play/pause or fire passed onClick
  const handleClick = (e) => {
    if (playPause) {
      const video = videoRef?.current;

      if (video) {
        if (video.paused) {
          video.play();
          setIsPlaying(true);
        } else {
          video.pause();
          setIsPlaying(false);
        }
      } else {
        // If no video ref, just toggle internal state
        setIsPlaying((prev) => !prev);
      }
    }

    if (props.onClick) {
      props.onClick(e);
    }
  };

  // Choose icon to display (play/pause logic or default icon)
  const CurrentIcon = playPause ? (isPlaying ? Pause : Play) : Icon;

  // Construct classes
  const wrapperClasses = `borderWrapper button-parent ${className} ${
    disabled ? "disabled" : ""
  }`;

  const buttonClasses = `button withIcon borderInner ${variant} ${size} ${
    disabled ? "disabled" : ""
  }`;

  // Main content (icon button)
  const content = (
    <button
      className={buttonClasses}
      disabled={disabled}
      onClick={handleClick}
      {...props}
    >
      <CurrentIcon size={size} />
    </button>
  );

  // If `to` is provided, render as a link
  if (to) {
    return disabled ? (
      <span className={`${wrapperClasses} disabledLink`} {...props}>
        {content}
      </span>
    ) : (
      <Link className={wrapperClasses} to={to} {...props}>
        {content}
      </Link>
    );
  }

  // Default button
  return <div className={wrapperClasses}>{content}</div>;
};

export default ButtonWithIcon;
